// Move the currency mapping outside of functions to avoid recreation
const COUNTRY_TO_CURRENCY = {
  'Afghanistan': 'AFN',
  'Albania': 'ALL',
  'Algeria': 'DZD',
  'Andorra': 'EUR',
  'Angola': 'AOA',
  'Argentina': 'ARS',
  'Armenia': 'AMD',
  'Australia': 'AUD',
  'Austria': 'EUR',
  'Azerbaijan': 'AZN',
  'Bahamas': 'BSD',
  'Bahrain': 'BHD',
  'Bangladesh': 'BDT',
  'Barbados': 'BBD',
  'Belarus': 'BYN',
  'Belgium': 'EUR',
  'Belize': 'BZD',
  'Bhutan': 'BTN',
  'Bolivia': 'BOB',
  'Bosnia and Herzegovina': 'BAM',
  'Botswana': 'BWP',
  'Brazil': 'BRL',
  'Brunei': 'BND',
  'Bulgaria': 'BGN',
  'Cambodia': 'KHR',
  'Cameroon': 'XAF',
  'Canada': 'CAD',
  'Chile': 'CLP',
  'China': 'CNY',
  'Colombia': 'COP',
  'Costa Rica': 'CRC',
  'Croatia': 'HRK',
  'Cuba': 'CUP',
  'Cyprus': 'EUR',
  'Czech Republic': 'CZK',
  'Denmark': 'DKK',
  'Dominican Republic': 'DOP',
  'Ecuador': 'USD',
  'Egypt': 'EGP',
  'El Salvador': 'USD',
  'Estonia': 'EUR',
  'Ethiopia': 'ETB',
  'Fiji': 'FJD',
  'Finland': 'EUR',
  'France': 'EUR',
  'Georgia': 'GEL',
  'Germany': 'EUR',
  'Ghana': 'GHS',
  'Greece': 'EUR',
  'Guatemala': 'GTQ',
  'Haiti': 'HTG',
  'Honduras': 'HNL',
  'Hong Kong': 'HKD',
  'Hungary': 'HUF',
  'Iceland': 'ISK',
  'India': 'INR',
  'Indonesia': 'IDR',
  'Iran': 'IRR',
  'Iraq': 'IQD',
  'Ireland': 'EUR',
  'Israel': 'ILS',
  'Italy': 'EUR',
  'Jamaica': 'JMD',
  'Japan': 'JPY',
  'Jordan': 'JOD',
  'Kazakhstan': 'KZT',
  'Kenya': 'KES',
  'Kuwait': 'KWD',
  'Kyrgyzstan': 'KGS',
  'Laos': 'LAK',
  'Latvia': 'EUR',
  'Lebanon': 'LBP',
  'Libya': 'LYD',
  'Lithuania': 'EUR',
  'Luxembourg': 'EUR',
  'Macau': 'MOP',
  'Macedonia': 'MKD',
  'Madagascar': 'MGA',
  'Malaysia': 'MYR',
  'Maldives': 'MVR',
  'Malta': 'EUR',
  'Mauritius': 'MUR',
  'Mexico': 'MXN',
  'Moldova': 'MDL',
  'Mongolia': 'MNT',
  'Montenegro': 'EUR',
  'Morocco': 'MAD',
  'Mozambique': 'MZN',
  'Myanmar': 'MMK',
  'Namibia': 'NAD',
  'Nepal': 'NPR',
  'Netherlands': 'EUR',
  'New Zealand': 'NZD',
  'Nicaragua': 'NIO',
  'Nigeria': 'NGN',
  'North Korea': 'KPW',
  'Norway': 'NOK',
  'Oman': 'OMR',
  'Pakistan': 'PKR',
  'Panama': 'PAB',
  'Papua New Guinea': 'PGK',
  'Paraguay': 'PYG',
  'Peru': 'PEN',
  'Philippines': 'PHP',
  'Poland': 'PLN',
  'Portugal': 'EUR',
  'Qatar': 'QAR',
  'Romania': 'RON',
  'Russia': 'RUB',
  'Rwanda': 'RWF',
  'Saudi Arabia': 'SAR',
  'Serbia': 'RSD',
  'Singapore': 'SGD',
  'Slovakia': 'EUR',
  'Slovenia': 'EUR',
  'Somalia': 'SOS',
  'South Africa': 'ZAR',
  'South Korea': 'KRW',
  'Spain': 'EUR',
  'Sri Lanka': 'LKR',
  'Sudan': 'SDG',
  'Sweden': 'SEK',
  'Switzerland': 'CHF',
  'Syria': 'SYP',
  'Taiwan': 'TWD',
  'Tajikistan': 'TJS',
  'Tanzania': 'TZS',
  'Thailand': 'THB',
  'Trinidad and Tobago': 'TTD',
  'Tunisia': 'TND',
  'Turkey': 'TRY',
  'Turkmenistan': 'TMT',
  'Uganda': 'UGX',
  'Ukraine': 'UAH',
  'United Arab Emirates': 'AED',
  'United Kingdom': 'GBP',
  'United States': 'USD',
  'Uruguay': 'UYU',
  'Uzbekistan': 'UZS',
  'Venezuela': 'VES',
  'Vietnam': 'VND',
  'Yemen': 'YER',
  'Zambia': 'ZMW',
  'Zimbabwe': 'ZWL'
};

// Currency details - also static
/**
 * Currency code → display name.
 *
 * This is the authoritative currency list (supplied by finance). It previously
 * held about twenty names, and the dropdown was built from whatever codes
 * COUNTRY_TO_CURRENCY happened to reference - so many currencies were missing
 * entirely and the rest rendered as a bare three-letter code with no name.
 */
const CURRENCY_DETAILS = {
  'AED': 'UAE Dirham',
  'AFN': 'Afghan Afghani',
  'ALL': 'Albanian Lek',
  'AMD': 'Armenian Dram',
  'ANG': 'Netherlands Antillean Guilder',
  'AOA': 'Angolan Kwanza',
  'ARS': 'Argentine Peso',
  'AUD': 'Australian Dollar',
  'AZN': 'Azerbaijan Manat',
  'BAM': 'Bosnia And Herzegovina Convertible Mark',
  'BBD': 'Barbadian Dollar',
  'BDT': 'Bangladeshi Taka',
  'BGN': 'Bulgarian Lev',
  'BHD': 'Bahraini Dinar',
  'BIF': 'Burundi Franc',
  'BIH': 'Bosnia-Herzegovina Convertible Mark',
  'BND': 'Brunei Dollar',
  'BOB': 'Bolivian Boliviano',
  'BRL': 'Brazilian Real',
  'BSD': 'Bahamian Dollar',
  'BTN': 'Bhutanese Ngultrum',
  'BWP': 'Botswanan Pula',
  'BYN': 'Belarusian Ruble',
  'BZD': 'Belize Dollar',
  'CAD': 'Canadian Dollar',
  'CDF': 'Congolese Franc',
  'CHF': 'Swiss Franc',
  'CLF': 'Chilean Unit Of Account',
  'CLP': 'Chilean Peso',
  'CNY': 'Chinese Yuan Renminbi',
  'COP': 'Colombian Peso',
  'CRC': 'Costa Rican Colon',
  'CVE': 'Cape Verdean Escudo',
  'CZK': 'Czech Koruna',
  'DJF': 'Djiboutian Franc',
  'DKK': 'Danish Krone',
  'DOP': 'Dominican Peso',
  'DZD': 'Algerian Dinar',
  'EGP': 'Egyptian Pound',
  'ERN': 'Eritrean Nakfa',
  'ETB': 'Ethiopian Birr',
  'EUR': 'European Euro',
  'FJD': 'Fijian Dollar',
  'FKP': 'Falkland Islands Pound',
  'GBP': 'Pound Sterling',
  'GEL': 'Georgian Lari',
  'GHS': 'Ghanaian Cedi',
  'GIP': 'Gibraltar Pound',
  'GMD': 'Gambian Dalasi',
  'GNF': 'Guinean Franc',
  'GTQ': 'Guatemalan Quetzal',
  'GYD': 'Guyanese Dollar',
  'HKD': 'Hong Kong Dollar',
  'HNL': 'Honduran Lempira',
  'HRK': 'Croatian Kuna',
  'HTG': 'Haitian Gourde',
  'HUF': 'Hungarian Forint',
  'IDR': 'Indonesian Rupiah',
  'ILS': 'Israeli New Shekel',
  'INR': 'Indian Rupee',
  'IQD': 'Iraqi Dinar',
  'IRR': 'Iranian Rial',
  'ISK': 'Icelandic Krona',
  'JMD': 'Jamaican Dollar',
  'JOD': 'Jordanian Dinar',
  'JPY': 'Japanese Yen',
  'KES': 'Kenyan Shilling',
  'KGS': 'Kyrgyzstani Som',
  'KHR': 'Cambodian Riel',
  'KMF': 'Comorian Franc',
  'KRW': 'South Korean Won',
  'KWD': 'Kuwaiti Dinar',
  'KYD': 'Cayman Islands Dollar',
  'KZT': 'Kazakhstani Tenge',
  'LAK': 'Lao Kip',
  'LBP': 'Lebanese Pound',
  'LKR': 'Sri Lankan Rupee',
  'LRD': 'Liberian Dollar',
  'LSL': 'Lesotho Loti',
  'LYD': 'Libyan Dinar',
  'MAD': 'Moroccan Dirham',
  'MDL': 'Moldovan Leu',
  'MGA': 'Malagasy Ariary',
  'MKD': 'Macedonian Denar',
  'MMK': 'Myanmar Kyat',
  'MNT': 'Mongolian Tugrik',
  'MOP': 'Macanese Pataca',
  'MRO': 'Mauritanian Ouguiya',
  'MUR': 'Mauritian Rupee',
  'MVR': 'Maldivian Rufiyaa',
  'MWK': 'Malawian Kwacha',
  'MXN': 'Mexican Peso',
  'MYR': 'Malaysian Ringgit',
  'MZN': 'Mozambican Metical',
  'NAD': 'Namibian Dollar',
  'NGN': 'Nigerian Naira',
  'NIO': 'Nicaraguan Cordoba',
  'NOK': 'Norwegian Krone',
  'NPR': 'Nepalese Rupee',
  'NZD': 'New Zealand Dollar',
  'OMR': 'Omani Rial',
  'PAB': 'Panamanian Balboa',
  'PEN': 'Peruvian Sol',
  'PHP': 'Philippine Peso',
  'PKR': 'Pakistani Rupee',
  'PLN': 'Polish Zloty',
  'PYG': 'Paraguayan Guarani',
  'QAR': 'Qatari Riyal',
  'RON': 'Romanian Leu',
  'RSD': 'Serbian Dinar',
  'RUB': 'Russian Ruble',
  'RWF': 'Rwandan Franc',
  'SAR': 'Saudi Arabian Riyal',
  'SCR': 'Seychellois Rupee',
  'SDG': 'Sudanese Pound',
  'SEK': 'Swedish Krona',
  'SGD': 'Singapore Dollar',
  'SHP': 'Saint Helena Pound',
  'SLL': 'Sierra Leonean Leone',
  'SOS': 'Somali Shilling',
  'SRD': 'Surinamese Dollar',
  'STN': 'Sao Tome And Principe Dobra',
  'SYP': 'Syrian Pound',
  'SVC': 'Salvadoran Colón',
  'SZL': 'Swazi Lilangeni',
  'THB': 'Thai Baht',
  'TJS': 'Tajikistani Somoni',
  'TMT': 'Turkmen Manat',
  'TND': 'Tunisian Dinar',
  'TOP': 'Tongan Paʻanga',
  'TRY': 'Turkish Lira',
  'TTD': 'Trinidad And Tobago Dollar',
  'TWD': 'New Taiwan Dollar',
  'TZS': 'Tanzanian Shilling',
  'UAH': 'Ukrainian Hryvnia',
  'UGX': 'Ugandan Shilling',
  'USD': 'United States Dollar',
  'UYU': 'Uruguayan Peso',
  'UZS': 'Uzbekistani Som',
  'VES': 'Venezuelan Bolivar',
  'VND': 'Vietnamese Dong',
  'VUV': 'Vanuatu Vatu',
  'WST': 'Samoan Tala',
  'XAF': 'Central African CFA Franc',
  'XCD': 'East Caribbean Dollar',
  'XOF': 'West African CFA Franc',
  'XPF': 'CFP Franc',
  'YER': 'Yemeni Rial',
  'ZAR': 'South African Rand',
  'ZMK': 'Zambian Kwacha (pre-2013)',
  'ZMW': 'Zambian Kwacha',
  // Reachable via COUNTRY_TO_CURRENCY but absent from the supplied list. Kept so
  // those countries still resolve to a currency that passes isValidCurrency.
  'CUP': 'Cuban Peso',
  'KPW': 'North Korean Won',
  'PGK': 'Papua New Guinean Kina',
  'ZWL': 'Zimbabwean Dollar',
};

/**
 * The selectable currency list: every code above, plus anything
 * COUNTRY_TO_CURRENCY can produce, so a country lookup can never return a code
 * the dropdown rejects. Sorted by code.
 */
const ALL_CURRENCIES = (() => {
  const codes = new Set([
    ...Object.keys(CURRENCY_DETAILS),
    ...Object.values(COUNTRY_TO_CURRENCY),
  ]);
  return [...codes].sort().map(code => ({
    code,
    name: CURRENCY_DETAILS[code] || code,
  }));
})();

export const getCurrencyCodeForCountry = (country) => {
  // Handle case variations
  const normalizedCountry = country.trim();
  
  // Try exact match first
  if (COUNTRY_TO_CURRENCY[normalizedCountry]) {
    return COUNTRY_TO_CURRENCY[normalizedCountry];
  }
  
  // Try case-insensitive match
  const countryLower = normalizedCountry.toLowerCase();
  for (const [key, value] of Object.entries(COUNTRY_TO_CURRENCY)) {
    if (key.toLowerCase() === countryLower) {
      return value;
    }
  }
  
  // If country contains a comma, try extracting just the country part
  if (normalizedCountry.includes(',')) {
    const parts = normalizedCountry.split(',');
    const countryPart = parts[parts.length - 1].trim();
    
    if (COUNTRY_TO_CURRENCY[countryPart]) {
      return COUNTRY_TO_CURRENCY[countryPart];
    }
    
    // Try case-insensitive for the extracted part
    const countryPartLower = countryPart.toLowerCase();
    for (const [key, value] of Object.entries(COUNTRY_TO_CURRENCY)) {
      if (key.toLowerCase() === countryPartLower) {
        return value;
      }
    }
  }
  
  // Default to USD if no match found
  console.warn(`No currency code found for country: ${country}, defaulting to USD`);
  return 'USD';
};

// Export the pre-calculated currencies list
export const getAllCurrencies = () => ALL_CURRENCIES;

// Helper function to check if a currency is valid
export const isValidCurrency = (currencyCode) => {
  return ALL_CURRENCIES.some(currency => currency.code === currencyCode.toUpperCase());
};
